import { TournamentInvitationWithDetails } from '../models';
import { TournamentInvitationRepository } from '../repositories/TournamentInvitationRepository';
import { logger } from '@/src/core/utils';

export class GetInvitationsReceivedUseCase {
  constructor(private invitationRepository: TournamentInvitationRepository) {}

  async execute(
    userId: string,
    limit: number = 20,
    offset: number = 0
  ): Promise<TournamentInvitationWithDetails[]> {
    logger.debug('GetInvitationsReceived', 'Loading received invitations', { userId });
    return this.invitationRepository.getReceived(userId, limit, offset);
  }
}
